import styled from 'styled-components';

export const ManageContactFormContextMenuWrapper = styled.div`
  position: relative;
  margin-left: 0.75rem;
  height: 32px;
  width: 2.5em;
`;
